export const getMetricValue = (
  metricsByName: Record<string, { value: number }>,
  name: string,
  defaultValue = 0,
) => metricsByName[name]?.value || defaultValue;
